// House of Lili サイズガイドモーダル
// document への委譲でイベントを張るため、セクションのモーフィング（再描画）後も動作する。
if (!window.__holSizeGuideInit) {
  window.__holSizeGuideInit = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = opener.closest('.size-guide')?.querySelector('dialog[data-size-guide-dialog]');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-size-guide-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // 背景（backdrop）クリックで閉じる
    const dialog = event.target.closest('dialog[data-size-guide-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });
}
